import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EquipmentMainComponent, SearchequipmentComponent,AddequimentComponent,MassUpdateComponent,MassTransferComponent,ManageoemComponent,NameManagerComponent

} from '../components';
import { AuthGuardService } from '../services';


const routes: Routes = [
    {
      path: '',
      component: SearchequipmentComponent,
      pathMatch: 'full',
      
      //pathMatch: 'full',
      //Start:Commented By Harikesh on 10-July-2020
      /*
        children: [
        {
          path: 'searchEquipment', component: SearchequipmentComponent 
        },
        {
          path: 'addEquipment', component: AddequimentComponent
        },
        {
          path: 'manageoem', component: ManageoemComponent
        }
      ]*/
      //End:Commented By Harikesh on 10-July-2020
    },
    {     
      path: 'searchEquipment',
      component: SearchequipmentComponent,
      pathMatch: 'full',
      canActivate: [AuthGuardService],
      data: { roles: ['ADMIN','BOM','BSS','ANALYST','HHD','BSSX','BOMX'],title:"Equipment Search" }
    },
    {     
      path: 'AddEquipment',
      component: AddequimentComponent,
      pathMatch: 'full',
      canActivate: [AuthGuardService],
      data: { roles: ['ADMIN','BOM','BSS','ANALYST','HHD','BSSX','BOMX'] ,title:"Add Equipment"}
    },
    {     
      path: 'MassUpdate',
      component: MassUpdateComponent,
      pathMatch: 'full',
      canActivate: [AuthGuardService],
      data: { roles: ['ADMIN','BOM','BSS','ANALYST','HHD','BSSX','BOMX'],title:"Mass Update" }
    },
    {     
      path: 'MassTransfer',
      component: MassTransferComponent,
      pathMatch: 'full',
      canActivate: [AuthGuardService],
      data: { roles: ['ADMIN','BOM','BSS','ANALYST','HHD','BSSX','BOMX'],title:"Mass Transfer" }
    },
    {     
      path: 'Manageoem',
      component: ManageoemComponent,
      pathMatch: 'full',
      canActivate: [AuthGuardService],
      data: { roles: ['ADMIN','BOM','BSS','ANALYST','HHD','BSSX','BOMX'],title:"Manage OEM" }
    },
    {
    path: 'NameManager',
    component: NameManagerComponent,
    pathMatch: 'full',
    canActivate: [AuthGuardService],
    data: { roles: ['ADMIN','BOM','BSS','ANALYST','HHD','BSSX','BOMX'] ,title:"Name Manager"}
  },
    
  ];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class EquipmentRoutingModule { }
